import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import {renderFieldSelect, requiredSelect} from '../../util/inputs';
import {alterarVeiculoItinerarioEmLote} from '../../actions/itinerario/alterarVeiculoItinerarioEmLote';
import {showSuccessMsg} from '../../util/messagesUtil';
import {tiposAndares} from '../../util/constantsUtil';
import moment from 'moment';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import DiasSemanaSelector from './DiasSemanaSelector'; // ajusta o caminho conforme a pasta

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class ModalAlteracaoVeiculoItinerarioEmLote extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.state = {dataInicio: null, dataFim: null, diasSelecionados: []}

    }

    buscarItinerarios() {
        this.props.buscarItinerarios();
    }

    montarParametroItinerario(values) {
        return {
            dataInicio: moment(this.state.dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(this.state.dataFim).format('YYYY-MM-DD'),
            idVeiculo: values.veiculo.value.id,
            empresaId: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            diasSelecionados: this.state.diasSelecionados ? this.state.diasSelecionados: [],
            andar: values.veiculo.value.seDoisAndares ? values.andar.value : 1
        }
    }

    fecharModal() {
        $('#modalAlteracaoVeiculoItinerarioEmLote')
            .modal('hide');
        $('#modalAlteracaoVeiculoItinerarioEmLote')
            .hide();        
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values)
        this.props.alterarVeiculoItinerarioEmLote(parametros)
            .then(() => {
                showSuccessMsg('Operação realizada com sucesso');
                this.fecharModal();
                this.buscarItinerarios()
            })
    }


    limparFormulario() {
        this.props.reset('formularioAlteracaoVeiculoItinerarioEmLote');
        this.setState({dataInicio: null, dataFim: null});
    }

    exibirComboVeiculo() {
        return <Field name='veiculo'
                      options={this.props.veiculos.map(elemento => ({
                          descricao: elemento.descricao,
                          nome: elemento
                      }))}
                      component={renderFieldSelect}
                      label="Veículo"
                      placeholder='Selecione o veículo' validate={requiredSelect}/>
    }

    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }


    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 5)
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalAlteracaoVeiculoItinerarioEmLote' role='dialog'
                 aria-labelledby='modalAlteracaoVeiculoItinerarioEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Alterar veículo em lote</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <span style={{color: 'red', fontWeight: 'bold'}}>*Esta alteração não se aplicará nos itinerários de categorias mistas</span>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <span style={{color: 'red', fontWeight: 'bold'}}>*Alteração de itinerários de tipo veículo embarcação só se aplicará para tipo veículo embarcação</span>
                                    </div>
                                     <div className="col-12 col-sm-4 col-md-4 mt-2">
                                          <label>Opera em quais dias da semana?</label>
                                          <DiasSemanaSelector
                                            diasSelecionados={this.state.diasSelecionados}
                                            onChange={(novosDias) => this.setState({ diasSelecionados: novosDias })}
                                          />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data de início</label>
                                        {this.exibirCalendario(true)}
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data fim</label>
                                        {this.exibirCalendario()}
                                    </div>
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                {this.exibirComboVeiculo()}
                                            </div>
                                        </div>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                {this.exibirComboAndar()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer mt-4">
                                    <button type="submit" disabled={invalid || submitting || !this.state.dataInicio
                                    || !this.state.dataFim}
                                            className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    exibirComboAndar() {
        if (this.props.veiculo && this.props.veiculo.value.seDoisAndares) {
            return <div>
                <Field name='andar'
                       options={tiposAndares.map(elemento => ({
                           descricao: elemento.label,
                           nome: elemento.value
                       }))}
                       component={renderFieldSelect}
                       label='Andar'
                       placeholder='Selecione o andar' validate={requiredSelect}/>
            </div>
        }
    }
}

export function mapStateToProps(state) {
    return {
        veiculo: formValueSelector('formularioAlteracaoVeiculoItinerarioEmLote')(state, 'veiculo'),
        empresaSelecionada: state.empresaSelecionada,
        itinerarioSelecionado: state.itinerarioSelecionado,
        tiposPreco: state.tiposPreco,
        veiculos: state.veiculos.veiculos,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        rotaSelecionada: state.rotaSelecionada

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        alterarVeiculoItinerarioEmLote
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlteracaoVeiculoItinerarioEmLote',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalAlteracaoVeiculoItinerarioEmLote));
